"use client";

import { useEffect, useRef, useState } from "react";

/**
 * Custom hook that returns whether the component is mounted.
 * Useful for preventing hydration mismatches and handling client-side only code.
 *
 * @example
 * ```tsx
 * export const ClientSideComponent = () => {
 *   const { isMounted, isMountedRef } = useMounted();
 *
 *   if (!isMounted) {
 *     return null;
 *   }
 *
 *   return <div>This only renders on the client</div>;
 * };
 * ```
 */
export const useMounted = () => {
  const [isMounted, setIsMounted] = useState(false);
  const isMountedRef = useRef(false);

  useEffect(() => {
    setIsMounted(true);
    isMountedRef.current = true;
  }, []);

  return { isMounted, isMountedRef };
};
